<!-- 污水处理厂弹框 -->
<template>
  <div class="dialog-sewage">
    <div class="header">
      <div class="title">{{ detail.psName }}</div>
    </div>
    <div class="body">
      <div class="left">
        <div class="top">
          <div class="descriptions-item">
            <span class="key">地理位置:</span>
            <span class="value">{{ detail.address || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">设计处理能力:</span>
            <span class="value">{{ detail.sssjrclnl || '-' }}万吨/日</span>
          </div>
          <div class="descriptions-item">
            <span class="key">排放去向类型:</span>
            <span class="value">{{ detail.psqxlx || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">排放标准:</span>
            <span class="value">{{ detail.pfbz || '-' }}</span>
          </div>
        </div>
        <div class="bottom">
          <n-select v-if="detail.videoList && detail.videoList.length > 0" v-model:value="active" size="small"
            :options="detail.videoList" @update:value="changeVideo" />
          <div v-if="detail.videoList && detail.videoList.length > 0" class="video-box">
            <div v-for="(item, index) in detail.videoList" :key="index" class="video-item">
              <div v-show="active === index" class="video">
                <video ref="video" controls class="video video-js vjs-default-skin vjs-big-play-centered"></video>
              </div>
              <div v-show="labelIsShow[index] && active === index" class="label" @click="play(index)">
                <div class="site-name">{{ item.output }}</div>
              </div>
            </div>
          </div>
          <img v-else class="no-video" :src="require('@/assets/img/no_video.png')" />
        </div>
      </div>
      <div class="right">
        <div class="row">
          <div class="select">
            <div class="key">排口：</div>
            <n-select v-model:value="outPutCode" size="small" :options="data.outPuts" @update:value="getData" />
          </div>
          <div class="select">
            <div class="key">监测因子：</div>
            <n-select v-model:value="factors" size="small" :options="factorsOpiton" @update:value="changFactor" />
          </div>
        </div>
        <div class="row select time">
          <div class="key">时间：</div>
          <n-date-picker v-model:value="startTime" size="small" type="datetime" clearable :on-update:value="stimeChange"
            format="yyyy-MM-dd HH" />
          <span class="line">--</span>
          <n-date-picker v-model:value="endTime" size="small" type="datetime" clearable :on-update:value="etimeChange"
            format="yyyy-MM-dd HH" />
        </div>
        <!-- <div class="row point">
          <div class="key">超标因子及百分比：</div>
          <div class="value">{{ cbyz }}</div>
        </div> -->
        <div class="echart">
          <div class="row">
            <div class="echart-btn" :class="{ active: timeUnit === 'hour' }" @click="select('时均值')">
              时均值
            </div>
            <div class="echart-btn" :class="{ active: timeUnit === 'day' }" @click="select('日均值')">
              日均值
            </div>
          </div>
          <div class="echart-sewag">
            <Sewage ref="sewag" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { wsclcCbFactorListUsingGET } from '@/api/api';
import { Api } from '@/api/publicApi'
import Sewage from '@/components/charts/Sewage.vue'
import Video from 'video.js'
import { NTooltip } from 'naive-ui'

const api = new Api()

export default {
  props: ['data'],
  components: { Sewage },
  data() {
    return {
      detail: { factors: [] },
      factorsOpiton: [],
      active: 0,
      outPutCode: '',
      factors: '',
      startTime: new Date(new Date() - 24 * 3600 * 1000),
      endTime: new Date(),
      timeUnit: 'hour',
      cbyz: '无', // 超标因子
      selectEchart: '时均值',
      // 列表数据
      listData: [],
      labelIsShow: [],
      // videojs视频对象节点
      player: [],
      // 视频数据
      videoData: [],
      currentTitle: '',
      echartData: [],
    }
  },
  created() {
    // console.log('outPuts', this.data)
    this.data.outPuts = JSON.parse(this.data.outPuts)
    for (let i = 0; i < this.data.outPuts.length; i++) {
      this.data.outPuts[i].label = this.data.outPuts[i].outPutName
      this.data.outPuts[i].value = this.data.outPuts[i].outPutCode
    }
  },
  mounted() {
    this.outPutCode = this.data.outPuts[0]?.outPutCode
    this.getWsclcDetail()
    this.$nextTick(() => {
      this.$refs.sewag.initChart()
    })
  },
  watch: {
    data: {
      immediate: true,
    },
  },
  methods: {
    renderOption(obj) {
      h(NTooltip, null, {
        trigger: () => obj.node,
        default: () => obj.option.label,
      })
    },
    //获取污水处理厂详情
    getWsclcDetail() {
      console.log(this.data)
      api.screen
        .wsclcDetailInfoUsingGet({
          psCode: this.data.psCode ? this.data.psCode : this.data.id,
          outPutCode: this.outPutCode,
        })
        .then((res) => {
          if (res.code == 200) {
            console.log('结果', res.data)
            this.detail = res.data
            this.active = 0
            if (this.detail.factors) {
              this.factors = this.detail.factors[0] ? this.detail.factors[0].code : ''
              this.factorsOpiton = this.detail.factors.map((val) => {
                return { label: val.name, value: val.code }
              })
            }
            if (this.detail.videoList) {
              for (let i = 0; i < this.detail.videoList.length; i++) {
                this.detail.videoList[i].label = this.detail.videoList[i].output
                this.detail.videoList[i].value = i
              }
            }
            console.log(this.detail.videoList, 'this.detail.videoList')

            this.getCbyz()
            setTimeout(() => {
              this.getVideo()
            }, 1000)
          }
        })
    },
    async select(val) {
      this.selectEchart = val
      switch (val) {
        case '时均值':
          this.startTime = new Date(new Date() - 24 * 3600 * 1000)
          this.endTime = new Date()
          this.timeUnit = 'hour'
          break
        case '日均值':
          this.startTime = new Date(new Date() - 7 * 24 * 3600 * 1000)
          this.endTime = new Date()
          this.timeUnit = 'day'
          break
        default:
          break
      }
      await this.getCbyz()
    },
    // 改变排污口时,获取监测因子
    async getData() {
      this.getWsclcDetail()
    },
    // 获取选择排污口的超标因子
    async getCbyz() {
      this.echartData = []
      let string = ''
      if (!this.outPutCode) {
        return
      }
      this.changFactor(this.factors)
    },

    changFactor(factor) {
      this.getEchart(factor)
    },

    async getEchart(factor) {
      const res = await api.screen.getWsclcGraphListUsingPost({
        endTime: this.format(this.endTime),
        outPutCode: this.outPutCode,
        factor: factor,
        startTime: this.format(this.startTime),
        type: this.timeUnit || '',
      })
      if (res.code == 200) {
        this.echartData = res.data
      }
      const XData = []
      const YData = []
      for (let i = 0; i < this.echartData.length; i += 1) {
        if (this.echartData[i].factor === factor) {
          XData.push(this.echartData[i].value)
          YData.push(this.echartData[i].dataTime)
        }
      }
      let stand
      if (this.echartData[0] && this.echartData[0].stand && this.echartData[0].stand[0]) {
        stand = parseFloat(this.echartData[0].stand[0])
      }
      this.$refs.sewag.initChart(XData, YData, stand)
    },

    getVideo() {
      const that = this
      if (this.detail.videoList.length > 0) {
        this.detail.videoList.forEach((item, index) => {
          const option = {
            muted: false,
            // controls: true,
            loop: false,
            autoplay: false,
            sources: [
              {
                type: '',
                src: item.videoPath, // url地址
              },
            ],
            notSupportedMessage: '此视频暂无法播放，请稍后再试',
            // poster:,
            // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
          }
          // 初始化的时候标签默认都是显示的
          this.labelIsShow.push(true)
          this.player[index] = Video(this.$refs.video[index], option, () => {
            // this.play();
            // 视频播放的时候标签隐藏
            that.player[index].on('play', () => {
              that.labelIsShow.splice(index, 1, false)
            })
            // 视频暂停的时候标签消失
            that.player[index].on('pause', () => {
              that.labelIsShow.splice(index, 1, true)
            })
            that.player[index].on('error', () => {
              that.player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
              console.log('视频加载错误')
            })
          })
        })
        this.player[this.active].play()
      }
    },
    changeVideo() {
      this.$nextTick(() => {
        this.getVideo()
      })
    },
    play(index) {
      this.player[index].play()
    },

    stimeChange(val) {
      this.startTime = val
      this.getCbyz()
    },
    etimeChange(val) {
      this.endTime = val
      this.getCbyz()
    },

    add0(m) {
      return m < 10 ? '0' + m : m
    },
    format(shijianchuo) {
      //shijianchuo是整数，否则要parseInt转换
      var time = new Date(shijianchuo)
      var y = time.getFullYear()
      var m = time.getMonth() + 1
      var d = time.getDate()
      var h = time.getHours()
      // var mm = time.getMinutes();
      // var s = time.getSeconds();
      // return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
      return y + '-' + this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h)
    },
  },
  beforeUnmount() {
    setTimeout(() => {
      console.log('组件销毁')
      this.player.forEach((item, index) => {
        item.dispose()
      })
    }, 200)
  },
}
</script>

<style lang="scss" scoped>
.dialog-sewage {
  min-width: 60rem;
  height: 42.65rem;

  .header {
    text-align: left;
    margin-bottom: 2rem;

    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 3.15rem;
      line-height: 3.15rem;
    }
  }

  .body {
    display: flex;

    .left {
      margin-right: 3rem;

      .top {
        .descriptions-item {
          min-width: 20rem;
          width: 300px;
          justify-content: space-between;
          height: 100%;
          min-height: 2.65rem;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          display: flex;

          .key {
            flex: 0 0 110px;
          }

          .value {}
        }
      }

      .bottom {
        margin-top: 4rem;
        position: relative;
        text-align: center;

        .n-select {
          width: 160px;
          top: -20px;
          text-align: left;
        }

        .video-box {
          position: relative;
          display: inline-block;

          .video-item {
            position: relative;

            ::v-deep .video-js * {
              font-size: 0.5rem;
            }

            ::v-deep .video-js {
              .vjs-big-play-button {
                font-size: 2rem;

                * {
                  font-size: 2rem;
                }
              }
            }

            &:nth-child(3n + 1) {
              margin-left: 0;
            }

            &:nth-child(1) {
              margin-top: 0;
            }

            &:nth-child(2) {
              margin-top: 0;
            }

            &:nth-child(3) {
              margin-top: 0;
            }

            .video {
              width: 24.3rem;
              height: 13.75rem;
            }

            .label {
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 123;
              width: 24.3rem;
              height: 2.35rem;
              background: rgba(0, 0, 0, 0.5);

              .site-name {
                margin-left: 1rem;
                font-size: 1.2rem;
                color: #d7d7d7;
                line-height: 2.35rem;
                text-align: left;
              }
            }
          }
        }

        .no-video {
          width: 20rem;
          height: 18.5rem;
        }
      }
    }

    .right {
      .row {
        display: flex;
        height: 3rem;
        line-height: 3rem;
        margin-bottom: 1.6rem;
      }

      .select {
        display: flex;
        width: 200px;
        height: 2.65rem;
        line-height: 2.65rem;
        margin-right: 5rem;

        &:last-of-type {
          margin-right: 0;
        }

        .key {
          white-space: nowrap;
        }

        .line {
          margin: 0 0.5rem;
        }
      }

      .time {
        width: 360px;
      }

      .echart {
        .row {
          margin-bottom: 1rem;
        }

        .echart-btn {
          width: 5.6rem;
          height: 2.4rem;
          line-height: 2.4rem;
          border: 0.025rem solid rgba(102, 146, 138, 0.8);
          border-radius: 0.1rem;
          cursor: pointer;
          text-align: center;

          &.active,
          &:hover {
            background: #00acff;
            border: 0.025rem solid rgba(102, 146, 138, 0.8);
            color: #ffffff;
          }
        }

        .echart-sewag {
          width: 450px;
          height: 170px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import '~@/assets/styles/dialog.scss';
</style>
